import React from 'react';

class Footer extends React.Component{
    render(){
        return(
            <footer className="footer">
                © & Privacy Policy | Business Toys Pvt. LTD
            </footer>
        )
    }
};

export default Footer;